<template>
  <div
    v-infinite-scroll="onScroll"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="0"
    :infinite-scroll-immediate-check="false"
  >
    <slot></slot>

    <slot name="loading" v-if="collection.hasMore() && collection.loading">
      <div class="box" style="position: relative; padding: 4rem;">
        <b-loading :is-full-page="false" active></b-loading>
      </div>
    </slot>
  </div>
</template>

<script>
import InfiniteScroll from "vue-infinite-scroll";

export default {
  directives: {
    InfiniteScroll
  },

  props: {
    collection: {
      required: true
    }
  },

  methods: {
    onScroll() {
      this.collection.load();
    }
  }
};
</script>
